import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';

export function getAdvancedReminderTypeOptions(): TSelectOption[] {
  return [
    {
      value: EAdvancedFilterOptions.IS_POINT_LINKED,
      label: translate('reminder_linked_to_point') + '.',
    },
    {
      value: EAdvancedFilterOptions.IS_NOT_POINT_LINKED,
      label: translate('is_not_point_linked') + '.',
    },
  ];
}
